import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {IEventType} from '../../dto/EventType.dto';
import axiosInstance, {apiGet} from '../../axiosConfig';
import {IApiDataResponse} from '../../dto/API.dto';

interface IEventTypeResponse {
  data: IEventType[];
}

export interface IEventsPayload {
  event_search?: string | null;
}

export const getAllSportsEventsApiPath = (company_id?: number) => {
  return company_id ? `/v1/company/${company_id}/event/list` : '/v1/events';
};

const getAllSports = (company_id?: number) => {
  return axiosInstance
    .get(getAllSportsEventsApiPath(company_id))
    .then((response: AxiosResponse<IEventTypeResponse>) => {
      return response.data?.data;
    });
};

export const useRqAllSports = (
  enabled: boolean = true,
  company_id?: number,
) => {
  return useQuery({
    queryKey: [getAllSportsEventsApiPath(company_id)],
    queryFn: () => getAllSports(company_id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};

/*
 * Events/Sports Unique api
 */
export const getSportsUniqueSearchApiPath = (company_id: number) =>
  `/v1/company/${company_id}/event/unique-search`;

const getSportsUnique = (company_id: number, search: string, id: number) => {
  return apiGet(getSportsUniqueSearchApiPath(company_id), {
    params: {name: search, id: id},
  }).then((response: AxiosResponse<{exist: boolean}>) => {
    return response.data;
  });
};

export const RqEventUniqueSearch = (
  company_id: number,
  search: string,
  id: number,
  enabled: boolean = true,
) => {
  const renderEnable = company_id > 0 && search !== '' ? enabled : false;
  return useQuery({
    queryKey: [getSportsUniqueSearchApiPath(company_id), search],
    queryFn: () => getSportsUnique(company_id, search, id),
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60,
    retry: false,
    enabled: renderEnable,
  });
};
/**
 *  Get Event Info
 */

export const getEventInfoApiPath = (company_id: number, event_id: number) => {
  return `/v1/company/${company_id}/event/${event_id}`;
};

const getEventInfo = (company_id: number, event_id: number) => {
  return axiosInstance
    .get(getEventInfoApiPath(company_id, event_id))
    .then((response: AxiosResponse<IApiDataResponse<IEventType>>) => {
      return response.data?.data;
    });
};

export const useRqEventInfo = (
  company_id: number,
  event_id: number,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: [getEventInfoApiPath(company_id, event_id)],
    queryFn: () => getEventInfo(company_id, event_id),
    refetchOnWindowFocus: false,
    retry: false,
    enabled: enabled,
  });
};
